export const ASSIGN_STAFF_EVALUATOR = '/assign-staff-evaluator'
export const STAFF_EVALUATION = '/staff-evaluation'
export const STAFF_EVALUATION_RESULT = `${ASSIGN_STAFF_EVALUATOR}/results/:id(\\d+)?`
